import { useTranslation } from 'react-i18next';

import { IUser } from '../../../lib/interfaces';

export const usePatientName = (patient: IUser): string => {
  const { t } = useTranslation();
  const name = [patient.firstName, patient.lastName].filter(Boolean).join(' ');
  if (name) return name;
  return t('videoVisit.patientFallback');
};
